<template>
	<v-list>
		<v-list-item v-for="item in items" :key="item.title" :to="item.route">
			<v-list-item-action>
				<v-avatar v-if="item.image" size="36px">
					<v-img :src="item.image" />
				</v-avatar>
				<v-icon v-else>{{ item.icon }}</v-icon>
			</v-list-item-action>
			<v-list-item-content>
				<v-list-item-title>{{ item.title }}</v-list-item-title>
			</v-list-item-content>
		</v-list-item>
	</v-list>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	computed: {
		...mapGetters({ items: "menu/items" }),
	},
};
</script>
